import React from 'react';
import { connect } from 'react-redux';
import { compose, isEmpty, mergeDeepRight, is } from 'ramda';
import { Map, fromJS } from 'immutable';


import SelectCountry from '@synergycms_core/components/functional/CustomerForm/SelectCountry.jsx';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import styleFile from './NewCofForm.js';
import Footer from '../../components/functional/Footer/Footer.jsx';
import { RichText, Image } from '@synergycms_core/components/generic';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import format from 'string-template';
import Form from '@synergycms_core/components/generic/Form';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import { getPenalties, getPenaltyTimezone, getPenaltyChargebackUSA } from '../../utils/penalties';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import moment from 'moment';
import { Loading } from '@synergycms_core/components/functional/Loading';
import { AR_STATES, PCI_URL, PROPERTY_MANAGEMENT_GROUP } from '../../config/constants';
import PciFrame from '../../components/functional/CustomerForm/PciFrame';
import { apiGetter } from '@synergycms_core/utils/api';
import { hashSpliter } from '@synergycms_core/utils';
import InputField from '@synergycms_core/components/generic/Form/InputField.jsx';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';

import RedsysClass from '@synergycms_core/utils/tpv/redsys';

import AvailMainSideSummaryTMS from '../../components/functional/AvailMainSideSummary/AvailMainSideSummaryTMS.jsx';

import actions from '../../store/actions';

const { customer: customerActions } = actions;

export const LoadingNewCof = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos confirmando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

const PaymentTitle = props => {
  const { classes, isTMSRequest } = props;
  const {
    reservation,
    fromTMS,
    fromPayLink,
    hotelName,
    reservationTMS,
    prepaymentAmount,
    prepaymentID,
    cardMask,
    isGroup
  } = props;

  const fullName = !fromTMS ? (
      (reservation.getIn(['customer', 'name']) ? ` ${reservation.getIn(['customer', 'name'])}` : '') +
      (reservation.getIn(['customer', 'surname']) ? ` ${reservation.getIn(['customer', 'surname'])}` : '')) :
    reservation.get('name');
  const fullTracking = `${reservation.get('hotel_code')}-${reservation.get('tracking_id')}`;
  const reservationType = (reservationTMS && reservationTMS.get('status_id') !== '02' && prepaymentID) || (fromPayLink && prepaymentAmount > 0);
  let cardMaskFormatted = cardMask && cardMask !== 'NO_TOKEN' ? cardMask.toString() : '';
  let cardMaskSeparated = cardMaskFormatted
    ? (cardMaskFormatted.replace(/^.{6}/g, '******').match(/.{1,4}/g) || []).join(' ')
    : '';

  const isExtraPayment = reservationTMS && reservationTMS.get('is_prepayment', false) && prepaymentID;
  const applySynergyText = !isTMSRequest || (isTMSRequest && (reservationTMS && !(reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01') && !isExtraPayment));
  let component;
  switch (true) {
    case (reservationTMS && (reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01') && prepaymentID) || (fromPayLink && prepaymentAmount > 0):
      component = <RichText translate={true} ucFirst={false}
                            text={'_%para poder finalizar el proceso de tu reserva, es necesario realizar el pago%_'}
                            innerStyle={['roboto16Black']} />;
      break;
    case reservationTMS && reservationTMS.get('status_id') !== '02' && reservationTMS.get('status_id') !== '01' && prepaymentID:
      component =
        <>
          <RichText
            translate={true}
            ucFirst={false}
            text={'_%puedes realizar el pago de tu reserva en el {hotelName} en concepto de {textAmount} por un importe de {amount}{currency}%_'}
            innerStyle={['roboto16Black']}
            withVars={{
              hotelName: hotelName,
              textAmount: reservationTMS.get('text'),
              amount: prepaymentAmount,
              currency: reservationTMS.get('currency')
            }}
          />
        </>;
      break;
    default:
      component =
        <>
          <RichText translate={true} ucFirst={false}
                    text={'_%por favor, para finalizar el proceso y garantizar tu estancia, actualiza los siguientes datos de tu tarjeta.%_'}
                    innerStyle={['roboto16Black']} />
        </>;
      break;
  }
  return (
    <div className={classes.resumeSimpleContainer}>
      <div className={classes.resumeSimple}>
        <div className={classes.title}>
          <Image innerStyle={classes.bookIcon} svg={reservationType ? 'bookIconNoCheck' : 'tmsCard'} />
          {
            reservationType ?
              <RichText translate={true} ucFirst={true} text={'_%reserva con pago pendiente%_'} /> :
              <RichText translate={true} ucFirst={true} text={'_%actualizar los datos de tu tarjeta%_'} />
          }
        </div>
        <div className={classes.locatorBox}>
          <RichText translate={true} ucFirst={true} text={'_%localizador%_'} innerStyle={classes.locatorTitle} />
          <RichText text={fullTracking} innerStyle={classes.locatorValue} />
        </div>
      </div>
      <div className={classes.resumeInformation}>
        {isGroup && <span><RichText translate={true} ucFirst={false}
                                    dangerouslySetInnerHTML={'_%Estimado,<br/>En referencia a%_'}
                                    innerStyle={['roboto16Black']} />&nbsp;</span>}
        {
          applySynergyText ? <div
            className={cardMask !== 'NO_TOKEN' && !fromTMS && !fromPayLink && !prepaymentAmount ? [classes.paddedText, classes.creditCard].join(' ') : classes.hide}>
            <RichText
              translate={true}
              ucFirst={true}
              text={
                '_%tarjeta actual%_'
              }
            />
            <RichText
              ucFirst={true}
              text={': ' + cardMaskSeparated}
            />
          </div> : ''
        }
        <div className={classes.reservationTMSText}>
          <RichText text={fullName} innerStyle={['roboto16Black', 'bold']} />&nbsp;
          {component}
        </div>
      </div>
    </div>
  );
};

const ConfirmationSimple = props => {
  const { classes } = props;
  const { reservation, fromTMS, reservationTMS, isExtraPayment, isTMSRequest, fromPayLink } = props;
  const fullName = !fromTMS ? (
      reservation.getIn(['customer', 'name']) +
      (reservation.getIn(['customer', 'surname']) ? ` ${reservation.getIn(['customer', 'surname'])}` : '')) :
    reservation.get('name');
  const email = isTMSRequest ? props.reservation.getIn(['email']) : reservation.getIn(['customer', 'email']);
  const phone = isTMSRequest ? props.reservation.getIn(['telephone'], false) : reservation.getIn(['customer', 'phone'], false);
  const fullTracking = `${reservation.get('hotel_code')}-${reservation.get('tracking_id')}`;
  return (
    <div className={classes.confirmationContainer}>
      <div className={classes.confirmationContent}>
        <div className={classes.customer}>
          <div className={classes.titleConfirmation}>
            <div>
                {isTMSRequest && <Image innerStyle={classes.bookIconConfirmation} svg={isExtraPayment ? 'bookIcon' : 'tmsCardCheck'} /> }
                {isTMSRequest && isExtraPayment ?
                  <RichText text={fullName} innerStyle={classes.subtitleConfirmation}/>
                  :
                  <RichText
                    translate={true}
                    ucFirst={true}
                    text={fromPayLink ? '_%¡Tu reserva ya está confirmada!%_' : '_%¡Tu reserva ya está garantizada!%_'}
                    innerStyle={classes.subtitleConfirmation}
                  />
                }
                {
                  isTMSRequest ? (
                    !isExtraPayment ?
                      <RichText translate={true} ucFirst={true}
                                text={'_%gracias por actualizar los datos de tu tarjeta%_'} /> :
                      <RichText translate={true} ucFirst={true} text={'_%tu pago se ha realizado correctamente%_'} />
                  ) : <RichText translate={true} ucFirst={true}
                                text={'_%gracias por actualizar los datos de tu tarjeta%_'} />
                }
                {!isTMSRequest && !isExtraPayment &&
                <div className={classes.subtitleConfirmationBox}>
                  <RichText translate={true} ucFirst={true} text={'_%En breve recibirás un correo electrónico con la confirmación de tu reserva.%_'} innerStyle={classes.subtitleDescConfirmation} />
                </div>}
            </div>
          </div>
          {fromTMS && !(isExtraPayment === true && reservationTMS.get('status_id') !== '02' && reservationTMS.get('status_id') !== '01') &&
            <div className={classes.body}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%en breve recibirás un email con la confirmación de tu reserva a%_'}
              />
              <a href={'mail:to'} className={classes.email}>
                {email}
              </a>
              {phone && (
                <span>
                .{' '}
                  <RichText
                    translate={true}
                    ucFirst={true}
                    text={'_%si necesitamos contactar contigo lo haremos a través del número de teléfono%_'}
                  />{' '}
                  <RichText text={phone} />
              </span>
              )}
            </div>}
        </div>
        <div className={classes.simpleBookingInfo}>
          <div className={classes.locatorBoxConfirmation}>
            <RichText translate={true} ucFirst={true} text={'_%localizador%_'} innerStyle={classes.locatorTitle} />
            <RichText text={fullTracking} innerStyle={classes.locatorValue} />
          </div>
        </div>
      </div>
    </div>
  );
};

class NewCofForm extends React.Component {
  static displayName = 'NewCofForm';
  /** @type {string} */
  formID = 'newCofForm';
  /** @type {boolean | string} */
  tpvEnabled = false;
  /** @type {boolean} */
  hasCVVFilled = false;
  /** @type {boolean} */
  showCountrySelector = false;
  /** @type {RedsysClass|null } */
  REDSYS = null;


  constructor(props) {
    super(props);
    const {
      hotel,
      cofStatusURL,
      reservation,
      reservationTMS,
      countries,
      showErrorNotification,
      prepaymentAmount,
      langCode
    } = this.props.config;

    this.tpvEnabled = hotel.getIn(['tpv', 'name'], false);

    const paymentToken = reservation && (reservation.getIn(['payment', 'token'], false) || reservation.getIn(['token'], false));
    if (typeof paymentToken === 'string') {
      this.paymentToken = paymentToken;
    }

    this.defaultCountry = this.selectedCountry =
      countries.find(country => country.get('alpha2') === this.props.config.defaultCountryCode) ||
      countries.find(country => country.get('alpha2') === 'ES');

    const hidePciFrame = prepaymentAmount > 0 && ['Redsys'].includes(this.tpvEnabled);

    this.state = {
      showCardValidationError: cofStatusURL === 'COF:ERROR',
      showPciFrame: !hidePciFrame,
      newCofSuccess: false,
      newCofError: false
    };

    const country = (reservation && reservation.getIn(['customer', 'country'], false)) || (reservationTMS && reservationTMS.get('country', false));
    this.showCountrySelector = !country;

    window.addEventListener('message', this.overrideHeight, false);
    if (this.tpvEnabled === 'Redsys' && prepaymentAmount > 0) {
      this.REDSYS = new RedsysClass({
        environment: process.env.TPV_ENVIROMENT || 'prod',
        reservation,
        hotel,
        tpvPaymentStatus: cofStatusURL,
        setReservationPayed: () => {}, //setReservationPayed dummy func
        showConfirmation: this.showConfirmation,
        showErrorNotification
      });

      this.REDSYS.initialize(
        hotel,
        reservation,
        country || this.selectedCountry,
        langCode.toLowerCase(),
        this.formID,
        showErrorNotification,
        this.state.payFormSelected
      );
    }
  }

  requestDirectPayment = (validForm, inputList, manageLoading) => {
    const {
      alreadyPayed
    } = this.props.config;

    if (manageLoading) {
      manageLoading(true);
    }

    if (alreadyPayed) {
      this.changeProcessState(true);
      manageLoading(false);
      return true;
    }

    return new Promise((resolve, reject) => {
      switch (this.tpvEnabled) {
        case 'Redsys':
          this.REDSYS.validatePayment();
          break;
        default:
          reject(Error('not valid form'));
          break;
      }
    }).then(response => {
      manageLoading(false);
      return true;
    }).catch(error => {
      manageLoading(false);
      return error;
    });
  };

  requestNewCof = (validForm, inputList, manageLoading) => {
    const { reservation, reservationTMS, fromTMS, tmsTracking } = this.props.config;
    let { prepaymentID } = this.props.config;
    const country = (reservation && reservation.getIn(['customer', 'country'], false)) || (reservationTMS && reservationTMS.get('country', false));
    if (country === 'AR') {
      this.props.config.saveCustomerData(validForm, inputList, 'state');
    }
    //const requestWithPCIFrame = inputList['newCard'].value;
    const requestWithPCIFrame = true;
    //const hasToken = typeof this.paymentToken === 'string' && this.paymentToken.length > 0;
    if (manageLoading) {
      manageLoading(true);
    }

    if (Number.isInteger(prepaymentID)) {
      const payment = reservationTMS.get('payment');
      const additional_cards = payment.get('additional_cards');
      const isPaid = additional_cards.some(prepayment =>
        prepayment.prepayment_id === prepaymentID && prepayment.state === 'payed'
      );
      if (isPaid) {
        this.changeProcessState(true);
        return true;
      }
    } else {
      prepaymentID = reservationTMS?.get('prepayment_id', false);
    }

    return new Promise((resolve, reject) => {
      //if (!prepaymentAmount && !this.hasCVVFilled && hasToken) {
      if (false) {
        this.receiveMessagePCIFunction = this.receiveMessage(validForm, inputList, resolve, reject);
        window.addEventListener('message', this.receiveMessagePCIFunction, false);
        this.pciFrameCVV.contentWindow.postMessage('submit_pci_form_cvv', PCI_URL);
      } else if (!requestWithPCIFrame) {
        const apiPci = apiGetter('pci');
        const trackingID = reservation.get('tracking_id');
        const hotelCode = reservation.get('hotel_code');
        const pinCode = reservation.get('pin_code');
        const tokenID = reservation.getIn(['payment', 'token']);
        const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingID + ':' + pinCode) }];
        const body = {
          hotel_code: hotelCode,
          token_id: tokenID,
          tpv: this.tpvEnabled,
          test: process.env.NODE_ENV !== 'production' ? 1 : 0,
          payment_recurring_type: 'newCof',
          location: window.location.href,
          from_tms: (fromTMS ? 1 : 0)
        };
        if (tmsTracking) {
          body.tms_tracking = tmsTracking;
        }
        if (prepaymentID) {
          body.prepayment_id = prepaymentID;
        }


        return apiPci.query('POST', 'CardsApp/requestWithCof', null, body, extraHeaders).then(response => {
          if (!(response.success === false)) {
            if (!(response.redirection_3ds === false)) {
              window.location.replace(response.redirection_3ds);
              return true;
            } else if (!(response.form === false)) {
              let form = atob(response.form);
              let queryObj = {};
              let redsysApi;
              if (form.indexOf('new') !== -1) {
                const [, creq, url] = form.split('#');
                queryObj.creq = creq;
                redsysApi = apiGetter(url, 'form');
              } else {
                const [, PaReq, TermUrl, MD, url] = form.split('#');
                queryObj.PaReq = PaReq;
                queryObj.TermUrl = TermUrl;
                queryObj.MD = MD;
                redsysApi = apiGetter(url, 'form');
              }
              redsysApi.post(queryObj);
              return true;

            } else {
              this.changeProcessState(true);
              return true;
            }
          } else {
            this.changeProcessState(false);
            return { error: 'Api Error' };
          }
        }).catch(() => {
          this.changeProcessState(false);
          return reject({ error: 'Api Error' });
        });
      } else {
        this.receiveMessagePCIFunction = this.receiveMessage(validForm, inputList, resolve, reject);
        window.addEventListener('message', this.receiveMessagePCIFunction, false);
        this.pciFrame.contentWindow.postMessage('submit_pci_form', PCI_URL);
      }
    });
  };

  changeProcessState = (success) => {
    const {
      reservation,
      fromPayLink,
      notRefundable,
      prepaymentAmount,
      changePayform
    } = this.props.config;


    this.setState(state => {
      if (success) {
        if (!!reservation && fromPayLink && reservation.getIn(['payment', 'payform_code'], false) === 'paylink') {
          let payForm = 'htl';
          if (!!this.tpvEnabled && prepaymentAmount > 0 && notRefundable) {
            payForm = 'op';
          }
          changePayform(reservation, payForm);
        }
        return {  showCardValidationError: false, newCofSuccess: true };
      } else {
        return { newCofError: true };
      }
    });
  };

  showConfirmation = (reservation, hotel) => {
    this.changeProcessState(true);
  };

  receiveMessage = (validForm, inputList, resolve, reject) => e => {
    const message = e.data;
    const { saveReservationToken, reservation } = this.props.config;
    if (e.origin === PCI_URL && message.indexOf('submit_booking_form_from_cvv') !== -1) {
      [, this.paymentToken] = message.split(':');
      if (this.paymentToken.length > 0) {
        this.hasCVVFilled = true;
        window.removeEventListener('message', this.receiveMessagePCIFunction, false);
        this.requestNewCof(validForm, inputList);
      }
    } else if (e.origin === PCI_URL && message.indexOf('submit_booking_form') !== -1) {
      [, this.paymentToken] = message.split(':');
      if (this.paymentToken.length > 0) {
        saveReservationToken(reservation, this.paymentToken, inputList);
        window.removeEventListener('message', this.receiveMessagePCIFunction, false);
        this.changeProcessState(true);
        resolve();
      }
    } else if (e.origin === PCI_URL && message.indexOf('error_booking_form_cvv') !== -1) {
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      // scroll to first unvalid
      this.pciFrameCVV.scrollIntoView();
      window.scrollBy(0, -65);
      reject();
    } else if (e.origin === PCI_URL && message.indexOf('error_booking_form') !== -1) {
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.setState(state =>
        mergeDeepRight(state, {
          showCardValidationError: true
        })
      );
      // scroll to first unvalid
      this.pciFrame.scrollIntoView();
      window.scrollBy(0, -65);
      reject();
    } else if (e.origin === PCI_URL && message.indexOf('redirect_3ds') !== -1) {
      const [, paymentToken, url3DSecureRedirection] = message.split('#');
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.paymentToken = paymentToken;
      window.location.replace(url3DSecureRedirection);
    } else if (e.origin === PCI_URL && message.indexOf('FORM') !== -1) {
      const [, paymentToken, form] = message.split('#');
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      let queryObj = {};
      let redsysApi;
      if (decodedForm.indexOf('new') !== -1) {
        const [, creq, url] = decodedForm.split('#');
        queryObj.creq = creq;
        redsysApi = apiGetter(url, 'form');
      } else {
        const [, PaReq, TermUrl, MD, url] = decodedForm.split('#');
        queryObj.PaReq = PaReq;
        queryObj.TermUrl = TermUrl;
        queryObj.MD = MD;
        redsysApi = apiGetter(url, 'form');
      }
      saveReservationToken(reservation, this.paymentToken, inputList);
      redsysApi.post(queryObj);
    }

    return true;
  };

  overrideHeight = e => {
    const message = e.data;
    if (e.origin === PCI_URL && message.indexOf('pci_iframe_with') !== -1) {
      let pciIframeHeight;
      [, pciIframeHeight] = message.split(':');
      if (!(parseInt(pciIframeHeight, 10) === 0 && parseInt(this.state.pciIframeHeight, 10) > 0)) {
        this.setState({
          pciIframeHeight: pciIframeHeight
        });
      }
    }
  };

  setPciFrameRef = ref => {
    this.pciFrame = ref;
  };

  setPciFrameCVVRef = ref => {
    this.pciFrameCVV = ref;
  };

  onBlur = (validForm, inputList, model, stateRetriever) => {
    if (model.indexOf('newCard') !== -1) {
      this.setState(state =>
        mergeDeepRight(state, {
          showPciFrame: inputList['newCard'].value
        })
      );
    } else {
      this.props.config.saveCustomerData(validForm, inputList, model);
    }
  };

  componentDidMount(prevProps, prevState, snapshot) {
    const { cofStatusURL, reservation, reservationTMS, hasCVV, tmsTracking } = this.props.config;

    if (hasCVV) {
      this.hasCVVFilled = true;
    }
    if (this.state.showCardValidationError) {
      this.refs['card_validation_error'].scrollIntoView();
    }

    const cofTxid = tmsTracking ? reservationTMS.getIn(['payment', 'cof_transaction_id'], false) : reservation.getIn(['payment', 'cof_transaction_id'], false);
    if (cofStatusURL === 'COF:OK' || (cofTxid !== false && !isEmpty(cofTxid))) {
      this.changeProcessState(true);
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { hasCVV } = this.props.config;

    if (hasCVV) {
      this.hasCVVFilled = true;
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('message', this.overrideHeight, false);
    window.removeEventListener('message', this.receiveMessagePCIFunction, false);
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };
  
  showLocationInputs = () => {
    const {hotel, fromTMS} = this.props.config;
    const hotelCountry = hotel && hotel.get('country_iso_code', '');

    const affectedCountries = ['US', 'MX', 'CA'];

    return affectedCountries.includes(hotelCountry) && fromTMS;
  }

  render() {
    const {
      reservation,
      hotel,
      cardMask,
      trackingFull,
      hasCVV,
      fromTMS,
      fromPayLink,
      countries,
      reservationTMS,
      tmsTracking,
      prepaymentID,
      isTMSRequest,
      langCode,
      pciLangCode,
      alreadyPayed
    } = this.props.config;

    let { prepaymentAmount } = this.props.config;
    const { content, theme } = this.props;

    if (hasCVV) {
      this.hasCVVFilled = true;
    }

    const hotelCode = hotel && hotel.get('code');
    const showCVC = hotel && hotel.getIn(['payment_info', 'show_cvc']) ? 1 : 0;
    const trackingId = reservation && reservation.get('tracking_id');
    const checkin = moment(reservation && reservation.get('checkin'));
    const stayLength = reservation && reservation.getIn(['blocks', 0, 'days']);
    const checkinPCI = checkin && moment(checkin).format('DDMMYYYY');
    const checkoutPCI =
      checkin &&
      moment(checkin)
        .add(stayLength, 'days')
        .format('DDMMYYYY');

    let phoneText = format(content.t(
        '_%no hemos podido validar tu tarjeta. Por favor, revisa que tus datos, la caducidad y el CVV sean correctos o prueba con otra tarjeta. Si el problema persiste puedes contactar con nuestra central de reservas llamando al {reservation_phone}.%_'),
      { reservation_phone: content.t('_%reservation_phone%_') }
    );

    const { classes } = this.props.theme.styles;
    const TPVActive = hotel && this.tpvEnabled !== false;
    const PSD2Active = hotel && hotel.getIn(['pci', 'psd2_active'], false) === true && !!hotel.getIn(['tpv', 'name'], false);
    const reservationTmsStatus = (reservationTMS.get('status_id') === '06' || reservationTMS.get('status_id') === '05') ? 'cancelled' : 'confirmed';
    const reservationStatus = fromTMS ? reservationTmsStatus : reservation.get('status', null);
    prepaymentAmount = prepaymentAmount === false ? reservationTMS && reservationTMS.get('amount', 0) : prepaymentAmount;
    const amountToPay = fromTMS ? prepaymentAmount :
      (prepaymentAmount ? prepaymentAmount : hotel.get('show_taxes') ? reservation.get('total_price_tax') : reservation.get('total_price'));

    //const hasToken = typeof this.paymentToken === 'string' && this.paymentToken.length > 0;
    //const totalPrice = reservationTMS ? parseFloat(reservationTMS.get('room_amount', 0)) + parseFloat(reservationTMS.get('extra_amount', 0)) : reservation.get('total_price_tax');
    const isExtraPayment = reservationTMS && prepaymentID && prepaymentAmount > 0;
    const isGroup = reservationTMS && reservationTMS.get('is_group', false);
    const hideGuaranteText = fromTMS && !(reservationTMS && (reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01'));
    const applySynergyText = !isTMSRequest || (!fromTMS && (reservationTMS && (reservationTMS.get('status_id') === '02' || reservationTMS.get('status_id') === '01') && !prepaymentAmount));
    const country = (reservation && reservation.getIn(['customer', 'country'], false)) || (reservationTMS && reservationTMS.get('country', false));    
    const showStateSelector = country === 'AR';
    const currentState = (reservation && reservation.getIn(['customer', 'state'], false)) || (reservationTMS && reservationTMS.get('state', false));
    const states = fromJS(AR_STATES);

    const submitEvent = prepaymentAmount > 0 && ['Redsys'].includes(this.tpvEnabled) ? this.requestDirectPayment : this.requestNewCof;
    let submitText = applySynergyText ? '_%actualizar tarjeta%_' : (isExtraPayment ? '_%realizar pago%_' : '_%confirmar reserva%_');
    if (fromPayLink && prepaymentAmount > 0) {
      submitText = ['Redsys', 'EPG'].includes(this.tpvEnabled) ? '_%realizar pago%_' : '_%confirmar reserva%_';
    }


    // Check if the prepayment is already paid
    if (prepaymentID) {
      const payment = reservationTMS.get('payment');
      const additional_cards = payment.get('additional_cards') || [];
      const isPaid = additional_cards.some(prepayment =>
        prepayment.get('prepayment_id') === prepaymentID && prepayment.get('state') === 'payed'
      );
      if (isPaid) {
        return (
          <>
            <ConfirmationSimple 
              reservation={reservation} 
              fromTMS={fromTMS} 
              classes={classes}
              reservationTMS={reservationTMS} 
              isExtraPayment={isExtraPayment}
              trackingFull={trackingFull} 
              isTMSRequest={isTMSRequest} 
              fromPayLink={fromPayLink} 
            />
          </>
        );
      }
    }

    if (!reservation) {
      return false;
    } else if (
      this.state.newCofSuccess ||
      (!fromPayLink && !TPVActive) ||
      alreadyPayed ||
      (fromPayLink && reservation.getIn(['payment', 'payform_code'], false) !== 'paylink')
    ) {
      return (
        <div className={classes.confirmationPageWrapper}>
          <ConfirmationSimple
            reservation={reservation}
            fromTMS={fromTMS}
            classes={classes}
            reservationTMS={reservationTMS}
            isExtraPayment={isExtraPayment}
            trackingFull={trackingFull}
            isTMSRequest={isTMSRequest}
            fromPayLink={fromPayLink}
          />
          <Footer />
        </div>
      );
    } else if (
      reservation.get('success') === false ||
      reservationStatus === 'cancelled' ||
      this.state.newCofError
    ) {
      return (
        <div className={classes.confirmationPageWrapper}>
          <div className={classes.newCofContainer}>
            <div>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%confirmación denegada%_'}
                innerStyle={[classes.mainTitle, 'mainColor']}
              />
            </div>
            <div className={classes.paddedText}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%ha ocurrido un problema al intentar confirmar esta reserva.%_'}
              />
            </div>
          </div>
          <Footer />
        </div>
      );
    } else if (reservationStatus === 'confirmed') {
      return (
        <div className={classes.defaultStyle}>
          <div className={classes.pendingContainer}>
            <div className={classes.payContainer}>
              <Form
                loadingTemplate={LoadingNewCof}
                onSubmit={submitEvent}
                onBlur={this.onBlur}
                id={this.formID}
                disableLoading={true}
                innerStyle={classes.customerForm}>

                <PaymentTitle 
                  reservation={reservation} 
                  fromTMS={fromTMS} 
                  classes={classes}
                  reservationTMS={reservationTMS}
                  isGroup={isGroup}
                  prepaymentID={prepaymentID}
                  prepaymentAmount={prepaymentAmount}
                  fromPayLink={fromPayLink}
                  hotelName={hotel.get('name')} 
                  isTMSRequest={isTMSRequest} 
                  cardMask={cardMask} 
                />

                <div className={classes.personalData}>
                  {(this.showCountrySelector || this.showLocationInputs() )&&
                    <label className={[classes.inputBox, classes.selectCountry].join(' ')}>
                      <SelectCountry 
                        defaultCountry={this.defaultCountry} 
                        countries={countries} 
                        arrowPosition={langCode}
                        hidePhonePrefix={true}
                        updateCard={true}/>
                    </label>
                  }
                  {showStateSelector &&
                    <label className={[classes.inputBox].join(' ')}>
                       <div className={classes.cityContainer}>
                        <SelectField
                          getOptionLabel={option => option.get('name')}
                          getOptionValue={option => option.get('code')}
                          model={'state'}
                          placeholder={""}
                          innerStyle={[classes.citySelector]}
                          defaultValue={states.find(s => s.get('code') === currentState) || states.first()}
                          options={states}
                        />
                      </div>
                    </label>
                  }
                  {this.showLocationInputs() && 
                  <>
                  {/* address */}
                    <label className={[classes.inputBox].join(' ')} ref={'address'}>
                      <InputField
                        model={'address'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'dirección' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'address'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%dirección%_'} translate={true} />
                    </label>
                    {/* city */}
                    <label className={[classes.inputBox].join(' ')} ref={'city'}>
                      <InputField
                        model={'city'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'ciudad' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'city'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%ciudad%_'} translate={true} />
                    </label>
                    {/* postal code */}
                    <label className={[classes.inputBox].join(' ')} ref={'postCode'}>
                      <InputField
                        model={'postCode'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'código postal' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'postCode'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%código postal%_'} translate={true} />
                    </label>
                  </>
                  }
                </div>

                <div className={classes.payComponent}>
                  {<div style={{ height: this.state.pciIframeHeight + 'px' }}
                        className={this.state.showPciFrame ? classes.wrapperPciFrame : classes.hide}>

                    <PciFrame
                      langCode={pciLangCode}
                      trackingId={trackingId}
                      tmsTracking={tmsTracking}
                      hotelCode={hotelCode}
                      checkinPCI={checkinPCI}
                      checkoutPCI={checkoutPCI}
                      showCVC={showCVC}
                      cfees15d={'0'}
                      tpvEnabled={this.tpvEnabled}
                      withCof={PSD2Active}
                      requiredPrepayment={fromTMS ? amountToPay : (prepaymentAmount ? prepaymentAmount : 0)}
                      prepaymentID={prepaymentID}
                      fromTms={fromTMS}
                      setRef={this.setPciFrameRef}
                      cardTokenId={false}
                      cardVerification={hotel.getIn(['pci', 'card_verification'], false)}
                      hideText={!isTMSRequest ? false : hideGuaranteText}
                    />
                  </div>}
                  {this.state.showCardValidationError && (
                    <div className={classes.errorPCI} ref={'card_validation_error'}>
                      <RichText
                        text={phoneText}
                        translate={true}
                        innerStyle={['errorForm15']}
                        ucFirst={true}
                      />
                    </div>
                  )}
                </div>
                <div className={classes.finalPrice}>
                  <div className={classes.tableContainer}>
                    <div className={[classes.buttonContainer, applySynergyText && classes.noPaddingButton].join(' ')}>
                      <ButtonSubmit
                        richText={{
                          text: submitText,
                          translate: true,
                          ucFirst: true,
                          innerStyle: ['toggleSecondButton']
                        }}
                        innerStyle={['toggleSecondButton']}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            </div>
            {!this.isMobile() && <div className={classes.resumeContainer}>
              <AvailMainSideSummaryTMS 
                innerStyle={'pendingConfirmationStyle'}
                prepaymentAmount={prepaymentAmount}
                newCofSuccess={this.state.newCofSuccess || (!TPVActive && !fromPayLink)}
                fullVersion={true}
                isGroup={isGroup} 
              />
            </div>
            }
          </div>
          <Footer />
        </div>
      );
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    saveCustomerData: (validForm, inputList, model) => {
      if (ownProps.fromTMS) {
        return dispatch(customerActions.reservation.patchTmsAsync([model], inputList));
      } else {
        return dispatch(customerActions.reservation.patchAsync([model], inputList));
      }
    },
    saveReservationToken: (reservation, token, inputList) => {
      dispatch(
        customerActions.reservation.set(reservation.setIn(['payment', 'token'], token))
      );
      return dispatch(customerActions.reservation.patchAsync(['card_token'], inputList, { paymentToken: token }));
    },
    showErrorNotification: text => {
      dispatch(actions.notifications.send('error', text));
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
    },
    changePayform: (reservation, payForm) => {
      dispatch(
        customerActions.reservation.patchAsync('payform_code', false, {
          payFormCode: payForm
        })
      );
      dispatch(customerActions.reservation.set(reservation.setIn(['payment', 'payform_code'], payForm)));
      return true;
    }
  };
};


const mapStateToProps = store => {
  const queryParams = store.getIn(['customer', 'params', 'url_params'], false);
  const fromTMS = store.getIn(['customer', 'params', 'url_params', 'from_tms'], false) === 'true';
  const fromPayLink = store.getIn(['customer', 'params', 'url_params', 'from_paylink'], false) === 'true';
  const tmsTracking = store.getIn(['customer', 'params', 'url_params', 'tms_tracking'], false);
  const prepaymentID = store.getIn(['customer', 'params', 'url_params', 'prepayment_id'], false);
  let prepaymentAmount = store.getIn(['customer', 'params', 'url_params', 'prepayment_amount'], false);
  const storeResevation = store.getIn(['customer', 'reservation']);
  const reservation = storeResevation.size ? storeResevation : undefined;
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotel = store.getIn(['hotels', hotelId], undefined);
  const managementGroupID = is(Map, hotel) && hotel.size > 0 && hotel.get('name') && hotel.get('management_group_id');

  let reservationTMS = reservation && (reservation.get('tms_reservation', false) || reservation);
  const isTMSRequest = fromTMS || (!fromTMS && tmsTracking);
  if (tmsTracking && reservationTMS && !fromTMS) {
    reservationTMS = reservationTMS.find(
      r => r.get('tracking_id') === parseInt(tmsTracking, 10)
    );
  }

  let langCode = reservationTMS && reservationTMS.getIn(['language'], false);
  if (!langCode) {
    langCode = reservation && (reservation.getIn(['customer', 'lang'], false));
  }
  if (!langCode) {
    langCode = 'en';
  }
  langCode = langCode.toLowerCase();

  const langInfo = store.getIn(['customer', 'lang_info']);
  let pciLangCode = langInfo.getIn(['code'], 'en');
  pciLangCode = pciLangCode.toLowerCase();
  if (pciLangCode === 'de') {
    pciLangCode = 'al';
  }

  const pms = hotel && hotel.get('pms');


  let penalties;
  if (!fromTMS) {
    penalties = reservation && reservation.get('success') !== false && getPenalties(reservation, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, langCode, managementGroupID, getPenaltyTimezone(hotel), getPenaltyChargebackUSA(hotel));
  }
  const notRefundable = fromTMS ? false : (penalties && (penalties[0].nr || penalties[0].flexible || false));
  const isVcCard = reservation && reservation.getIn(['payment', 'payform_code'], false) === 'vc';

  const cardMask = isVcCard ? 'NO_TOKEN' : store.getIn(['customer', 'card_mask']);
  const hasCVV = store.getIn(['customer', 'has_cvv']);
  const cofStatusURL = hashSpliter(window.location.hash)[3] || false;

  let trackingFull = reservation && (reservation.get('hotel_code') + '-' + reservation.get('tracking_id'));
  const isCnnBooking = reservation && reservation.getIn(['connectivity', 'code'], false) && reservation.getIn(['connectivity', 'tracking_id'], false);

  if (isCnnBooking && !!reservation) {
    let connectivityCode = reservation.getIn(['connectivity', 'code'], false);
    if (connectivityCode === 'ECIOLD') {
      connectivityCode = 'ECI';
    }
    if (connectivityCode === 'BOOKINGS') {
      connectivityCode = 'BOOKING';
    }
    trackingFull = connectivityCode + '-' + reservation.getIn(['connectivity', 'tracking_id']);
  }

  let alreadyPayed = false;

  if (!!reservation && !prepaymentAmount && fromPayLink && notRefundable) {
    const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
    const withTaxes = hotel && hotel.get('show_taxes', true);
    const amountTaxes = withTaxes ? reservation.get('total_price_tax', 0) : reservation.get('total_price', 0);
    const totalPointsPrice = reservation?.getIn(['loyalty', 'total_points_price'], 0);
    prepaymentAmount = amountTaxes - amountPromoPaid - totalPointsPrice;

    alreadyPayed = reservation.getIn(['payment', 'state']) === 'payed';
  }

  return {
    params: store.getIn(['customer', 'params', 'params']),
    queryParams: queryParams || undefined,
    reservation: reservation,
    reservationTMS: reservationTMS,
    penalties: !fromTMS ? penalties : [],
    hotel: hotel,
    cardMask: cardMask && cardMask.length > 0 ? cardMask : (typeof hasCVV.error ? false : undefined),
    hasCVV: typeof hasCVV === 'boolean' ? hasCVV : (typeof hasCVV.error ? false : undefined),
    cofStatusURL: cofStatusURL,
    trackingFull: trackingFull,
    fromTMS: fromTMS,
    fromPayLink: fromPayLink,
    tmsTracking: tmsTracking,
    prepaymentID: prepaymentID,
    prepaymentAmount: prepaymentAmount,
    alreadyPayed: alreadyPayed,
    showTaxes: is(Map, hotel) && hotel.size > 0 && hotel.get('name') && hotel.get('show_taxes', true),
    isTMSRequest: isTMSRequest,
    countries: store.get('countries'),
    langInfo: langInfo,
    langCode: langCode,
    pciLangCode: pciLangCode,
    notRefundable: notRefundable
  };
};


const fragment = props => (
  <React.Fragment>
    <Loading image={{ innerStyle: ['displayNone'] }} />
  </React.Fragment>
);

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'params',
    'reservation',
    'reservationTMS',
    'cancelReservation',
    'triggerEvent',
    'saveCustomerData',
    'saveReservationToken',
    'penalties',
    'hotel',
    'countries',
    'cardMask',
    'hasCVV',
    'cofStatusURL',
    'trackingFull',
    'fromTMS',
    'fromPayLink',
    'tmsTracking',
    'prepaymentID',
    'prepaymentAmount',
    'alreadyPayed',
    'showTaxes',
    'isTMSRequest',
    'queryParams',
    'langInfo',
    'langCode',
    'pciLangCode',
    'showErrorNotification',
    'notRefundable',
    'changePayform'
  ]),
  withThemeJSS({ styleFile, link: true, index: 200 }),
  withContent('i18n')
)(NewCofForm);
